import { createNode } from '@glueapp/graph-types';
export const GetObjectProperties = createNode({
    id: 'Get Object Properties',
    name: 'Get Object Properties',
    description: 'Get the properties of an object',
    aiDescription: [
        'Destructures an object into individual property output ports.',
        'Setup:',
        '1. Add the node: glue add "Get Object Properties"',
        '2. Connect an object-typed output from another node to the "Object" input port:',
        '   glue connect <object-node>:Output <id>:Object',
        '3. Run glue shape <id> to see the generated output ports (one per property of the connected object type).',
        '',
        'computeShape reads the resolved type of the connected "Object" input port. When an object-typed',
        "connection is present, it creates one output port per property matching the object's type definition.",
        'Without a connection, there are no dynamic output ports.',
        '',
        'The "Object" input port is generic with an object constraint, so it accepts any object type.',
        "Output ports are named after the object's property names and typed to match each property.",
        '',
        'Example - extract properties from an Object node:',
        '  glue add "Get Object Properties"  # returns <id>',
        '  glue connect <object-node>:"Created Object" <id>:Object',
        "  glue shape <id>  # shows output ports matching the connected object's properties",
    ].join('\n'),
    category: 'Object',
    color: '#a17ee2',
    integration: undefined,
    inPorts: {
        Object: {
            kind: 'generic',
            identifier: 'T',
            extends: {
                kind: 'object',
                restriction: 'open',
                properties: {},
            },
        },
    },
    outPorts: {},
    computeShape: input => {
        const inputObjectInputPort = input.preResolvedInputPorts.find(port => port.name === 'Object');
        if (
            inputObjectInputPort &&
            inputObjectInputPort.type &&
            inputObjectInputPort.type.kind === 'generic' &&
            inputObjectInputPort.type.resolvedType?.kind === 'object'
        ) {
            return {
                inPorts: [inputObjectInputPort],
                outPorts: Object.entries(inputObjectInputPort.type.resolvedType.properties).map(([propName, propType]) => ({
                    name: propName,
                    type: propType,
                })),
            };
        } else {
            return { inPorts: input.nodeInPorts, outPorts: input.nodeOutPorts };
        }
    },
    execute: function (input) {
        const resolvedInputObject = input.inPorts.Object;
        return { output: { ...resolvedInputObject } };
    },
});
